var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DiscoverPage from '../Pages/DiscoverPage';
import SpicePackPage from '../Pages/SpicePackPage';
import UserRecipesPage from '../Pages/UserRecipesPage';
import UserAccountPage from '../Pages/UserAccountPage';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import NavigationMenuThree from '../Navigation/NavigationMenuThree';
import './App.css';
import './HideScrollbar.css';
import { useEffect, useState } from 'react';
import { HOST_Server, PATH_APICURRENTVERSION, PATH_Account, PATH_Account_NewAccount, PATH_FrontEnd_SharedRecipe } from '../../config/config.dev';
import AboutPage from '../Pages/AboutPage';
import SupportPage from '../Pages/SupportPage';
var ProtectedUserProfilePage = withAuthenticationRequired(UserAccountPage);
var ProtectedUserRecipesPage = withAuthenticationRequired(UserRecipesPage);
var ProtectedSupportPage = withAuthenticationRequired(SupportPage);
import { Helmet } from "react-helmet";
import RedirectPage from '../Pages/RedirectPage';
var AppRouter = function () {
    /*
    When rendering the layout, check if signed in or not.
  
  1. If not signed in, render as expected.
  
  2. If signed in, and account created, render as expected.
  
  3. If signed in, and account not created, then render NUE (New User Experience)
  
    -> Back End
      -> Creates User Account
    -> Front End
      -> Calls Back End
      -> Shows nice loading page/welcome page
      -> Once back end is done creating account
        -> Set Session Info for the new account so we don't make this call again
        -> redirect to https://tastefolia.com/home
      -> (optional) New User Questionaire...
    */
    var _a = useAuth0(), user = _a.user, isAuthenticated = _a.isAuthenticated;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _b = useState(true), isLoadingScreenShown = _b[0], setIsLoadingScreenShown = _b[1];
    var _c = useState(false), userCreationVerified = _c[0], setUserCreationVerified = _c[1];
    // Handle Account Creation 
    useEffect(function () {
        if (isAuthenticated && !userCreationVerified) {
            // Check if user does not exist
            // todo consolidate this into helper :D
            var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
                var accessToken, response, responseData, emailToSend, response_1, responseData_1, error_1;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 8, , 9]);
                            return [4 /*yield*/, getAccessTokenSilently()];
                        case 1:
                            accessToken = _c.sent();
                            return [4 /*yield*/, fetch("".concat(HOST_Server).concat(PATH_APICURRENTVERSION).concat(PATH_Account), {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(accessToken),
                                    },
                                })];
                        case 2:
                            response = _c.sent();
                            return [4 /*yield*/, response.json()];
                        case 3:
                            responseData = _c.sent();
                            if (!!((_a = responseData[0]) === null || _a === void 0 ? void 0 : _a.userId)) return [3 /*break*/, 6];
                            emailToSend = { email: (_b = user === null || user === void 0 ? void 0 : user.email) !== null && _b !== void 0 ? _b : "undefined" };
                            return [4 /*yield*/, fetch("".concat(HOST_Server).concat(PATH_APICURRENTVERSION).concat(PATH_Account, "/").concat(PATH_Account_NewAccount), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(accessToken),
                                    },
                                    body: JSON.stringify(emailToSend)
                                })];
                        case 4:
                            response_1 = _c.sent();
                            if (!response_1.ok) {
                                // If the response is not 2xx, it is considered an error
                                throw new Error("HTTP error! status: ".concat(response_1.status));
                            }
                            return [4 /*yield*/, response_1.json()];
                        case 5:
                            responseData_1 = _c.sent();
                            if (responseData_1 === null || responseData_1 === void 0 ? void 0 : responseData_1.userId) {
                                setIsLoadingScreenShown(false);
                                setUserCreationVerified(true);
                            }
                            return [3 /*break*/, 7];
                        case 6:
                            // User exists
                            // todo: This could be a good place to check for expiry of account
                            // todo: this could be a good place to check for terms
                            setIsLoadingScreenShown(false);
                            setUserCreationVerified(true);
                            _c.label = 7;
                        case 7: return [3 /*break*/, 9];
                        case 8:
                            error_1 = _c.sent();
                            console.error('Error fetching data:', error_1);
                            return [3 /*break*/, 9];
                        case 9: return [2 /*return*/];
                    }
                });
            }); };
            fetchData();
        }
    }, [isAuthenticated, isLoadingScreenShown]);
    // if (isLoadingScreenShown && accessToken) {
    //   return (<LoadingPage />);
    // }
    // if (isLoadingScreenShown && accessToken === undefined) {
    //   let buttons = <Box sx={{ '& > :not(style)': { m: .5 } }}>
    //                   <LoginButton />
    //                 </Box>
    //   return (<LoadingPage>{buttons}</LoadingPage>);
    // }
    var sharePageUrl = "/" + PATH_FrontEnd_SharedRecipe;
    return (_jsxs(Router, { children: [_jsxs(Helmet, { children: [_jsx("link", { rel: "icon", href: "/favicon.ico" }), _jsx("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }), _jsx("meta", { name: "theme-color", content: "#000000" }), _jsx("meta", { name: "description", content: "MealGenie.io: Your ultimate recipe management platform and spice order service. Discover new recipes, order premade or custom spice packs, and elevate your cooking experience." }), _jsx("meta", { property: "og:title", content: "MealGenie.io: Recipe Management & Spice Order Service" }), _jsx("meta", { property: "og:description", content: "Discover new recipes, order premade or custom spice packs, and elevate your cooking experience with MealGenie.io." }), _jsx("meta", { property: "og:image", content: "/mealgenielogofav485.png" }), _jsx("meta", { property: "og:url", content: "https://mealgenie.io/" }), _jsx("meta", { property: "og:type", content: "website" }), _jsx("meta", { name: "twitter:card", content: "summary_large_image" }), _jsx("meta", { name: "twitter:title", content: "MealGenie.io: Recipe Management & Spice Order Service" }), _jsx("meta", { name: "twitter:description", content: "Discover new recipes, order premade or custom spice packs, and elevate your cooking experience with MealGenie.io." }), _jsx("meta", { name: "twitter:image", content: "/mealgenielogofav485.png" }), _jsx("title", { children: "MealGenie.io: Recipe Management & Spice Order Service" }), _jsx("link", { rel: "apple-touch-icon", href: "/mealgenielogofav485.png" }), _jsx("link", { rel: "manifest", href: "/manifest.json" })] }), _jsx("div", __assign({ className: "appPadding", id: "mainContent" }, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "*", Component: RedirectPage }), _jsx(Route, { path: "/", Component: DiscoverPage }), _jsx(Route, { path: "/about", Component: AboutPage }), _jsx(Route, { path: "/profile", Component: ProtectedUserProfilePage }), _jsx(Route, { path: "/support", Component: ProtectedSupportPage }), _jsx(Route, { path: "/recipes", Component: ProtectedUserRecipesPage }), _jsx(Route, { path: "/spicepack", element: _jsx(SpicePackPage, { isSpicePack: true, isDeepLink: true }) }), _jsx(Route, { path: sharePageUrl, element: _jsx(SpicePackPage, { isShareOnly: true, isDeepLink: true }) })] }) })), _jsx(NavigationMenuThree, {})] }));
};
export default AppRouter;
